import { render } from "./PropertyItemAgent.vue?vue&type=template&id=b07a7b00&scoped=true"
import script from "./PropertyItemAgent.vue?vue&type=script&lang=js"
export * from "./PropertyItemAgent.vue?vue&type=script&lang=js"

import "./PropertyItemAgent.vue?vue&type=style&index=0&id=b07a7b00&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b07a7b00"]])

export default __exports__